import React from "react";
import { CardProps } from '../interFaces/interfaces';
import "../css/others/Table.css";
const Card: React.FC<CardProps> = ({ label, value, icon, extraContent }) => (
  <div className="card">
    <div className="card-inner">
      {icon}
      <div>
        <label className="label">{label}:</label>
        {typeof value === "string" || typeof value === "number" ? (
          <p className="value">{value}</p>) : (value
        )}
      </div>
      {extraContent && <div className="extra-content">{extraContent}</div>}
    </div>
  </div>
);
export default Card;